/* Photo-normalised production templates. No physical dimensions are inferred. */
(function(root,factory){
  if(typeof module==='object'&&module.exports)module.exports=factory();
  else root.OrienXEngravingLayout=factory();
})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  const templates={
    'gobelet-brume':{cx:.492,cy:.492,rx:.151,ry:.153,logo:{x:.412,y:.414,w:.155,h:.143},below:.590,above:.377,size:.018,ink:'#655f52',alpha:.68},
    'bol-du-matin-brume':{cx:.500,cy:.462,rx:.155,ry:.152,logo:{x:.421,y:.387,w:.156,h:.145},below:.574,above:.345,size:.018,ink:'#81715a',alpha:.64},
    'grand-bol-bas-brume':{cx:.510,cy:.501,rx:.129,ry:.129,logo:{x:.457,y:.444,w:.107,h:.117},below:.592,above:.407,size:.015,ink:'#838079',alpha:.33},
    'bol-bas-brume':{cx:.495,cy:.493,rx:.127,ry:.128,logo:{x:.421,y:.418,w:.147,h:.151},below:.594,above:.390,size:.015,ink:'#85817a',alpha:.32},
    'assiette-creuse-aile-brume':{cx:.497,cy:.485,rx:.125,ry:.126,logo:{x:.443,y:.429,w:.112,h:.119},below:.578,above:.391,size:.014,ink:'#817d73',alpha:.32},
    'assiette-gourmet-brume':{cx:.493,cy:.482,rx:.127,ry:.130,logo:{x:.433,y:.438,w:.125,h:.105},below:.579,above:.389,size:.015,ink:'#88765e',alpha:.52},
    'saladier-sable':{cx:.493,cy:.505,rx:.262,ry:.259,logo:{x:.432,y:.440,w:.139,h:.137},below:.635,above:.365,size:.022,ink:'#858177',alpha:.30},
    'grand-saladier-sable':{cx:.500,cy:.481,rx:.262,ry:.261,logo:{x:.419,y:.405,w:.159,h:.146},below:.625,above:.345,size:.022,ink:'#8b7960',alpha:.62},
    'bol-profond-quotidien-brume':{cx:.492,cy:.510,rx:.215,ry:.211,logo:{x:.418,y:.446,w:.152,h:.147},below:.640,above:.380,size:.020,ink:'#80694d',alpha:.72}
  };
  const finite=Number.isFinite;
  function geometryFor(handle){
    const t=templates[handle];
    return t?{...t,logo:{...t.logo},presets:{below:{x:t.cx,y:t.below},above:{x:t.cx,y:t.above},left:{x:(t.cx-t.rx+t.logo.x)/2,y:t.cy},right:{x:(t.logo.x+t.logo.w+t.cx+t.rx)/2,y:t.cy}},version:'20261015-2'}:null;
  }
  function orientedBox(box,angle=0){
    if(![0,90].includes(angle))throw TypeError('Unsupported engraving direction');
    return angle===90?{w:box.h,h:box.w}:{w:box.w,h:box.h};
  }
  function canPlace(p,b,g){
    if(!g||![p?.x,p?.y,b?.w,b?.h].every(finite)||b.w<=0||b.h<=0)return false;
    const x0=p.x-b.w/2,x1=p.x+b.w/2,y0=p.y-b.h/2,y1=p.y+b.h/2;
    if(x0<0||x1>1||y0<0||y1>1)return false;
    for(const x of [x0,x1])for(const y of [y0,y1])if(((x-g.cx)/g.rx)**2+((y-g.cy)/g.ry)**2>1+1e-9)return false;
    const l=g.logo;
    return x1<=l.x||x0>=l.x+l.w||y1<=l.y||y0>=l.y+l.h;
  }
  function nearestPlacement(p,b,g,side=null){
    if(!g||b.w>2*g.rx||b.h>2*g.ry)return null;
    if(!p||!finite(p.x)||!finite(p.y))p=g.presets.below;
    const allowed=q=>canPlace(q,b,g)&&(!side||(side==='below'&&q.y-b.h/2>=g.logo.y+g.logo.h)||(side==='above'&&q.y+b.h/2<=g.logo.y)||(side==='left'&&q.x+b.w/2<=g.logo.x)||(side==='right'&&q.x-b.w/2>=g.logo.x+g.logo.w));
    if(allowed(p))return{x:p.x,y:p.y};
    let best=null,score=Infinity;
    const consider=q=>{if(allowed(q)){const d=(q.x-p.x)**2+(q.y-p.y)**2;if(d<score){score=d;best=q;}}};
    Object.values(g.presets).forEach(consider);
    const step=.003;
    for(let y=g.cy-g.ry+b.h/2;y<=g.cy+g.ry-b.h/2;y+=step){
      for(let x=g.cx-g.rx+b.w/2;x<=g.cx+g.rx-b.w/2;x+=step)consider({x,y});
    }
    return best;
  }
  function projectMove(from,to,b,g){
    const start=canPlace(from,b,g)?from:nearestPlacement(from,b,g);
    if(!start)return null;
    if(!to||!finite(to.x)||!finite(to.y))return{...start};
    if(canPlace(to,b,g))return{x:to.x,y:to.y};
    let good=0,bad=1;
    for(let i=1;i<=32;i++){
      const t=i/32,p={x:start.x+(to.x-start.x)*t,y:start.y+(to.y-start.y)*t};
      if(!canPlace(p,b,g)){bad=t;break;}
      good=t;
    }
    for(let i=0;i<16;i++){
      const t=(good+bad)/2,p={x:start.x+(to.x-start.x)*t,y:start.y+(to.y-start.y)*t};
      if(canPlace(p,b,g))good=t;else bad=t;
    }
    return{x:start.x+(to.x-start.x)*good,y:start.y+(to.y-start.y)*good};
  }
  function pointFromClient(x,y,r){return{x:(x-r.left)/r.width,y:(y-r.top)/r.height};}
  function multipartItems(items){
    const body=new FormData();
    items.forEach((item,i)=>{
      for(const [key,value]of Object.entries(item)){
        if(value==null)continue;
        if(key==='properties'){
          for(const [name,property]of Object.entries(value)){
            const path=`items[${i}][properties][${name}]`;
            if(property instanceof Blob)body.append(path,property,property.name||'engraving.png');
            else body.append(path,String(property));
          }
        }else body.append(`items[${i}][${key}]`,String(value));
      }
    });
    return body;
  }
  function isUploadedPNG(value){
    try{const u=new URL(value);return u.protocol==='https:'&&u.hostname==='cdn.shopify.com'&&u.pathname.includes('/uploads/')&&/\.png$/i.test(u.pathname);}catch{return false;}
  }
  return{geometryFor,orientedBox,canPlace,nearestPlacement,projectMove,pointFromClient,multipartItems,isUploadedPNG};
});
